import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Grid,
  IconButton,
  Typography,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../redux/hooks";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import SearchIcon from "@mui/icons-material/Search";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import {
  MerchantColumns,
  merchantMetaData,
} from "../../static-models/MerchantData";
import theme from "../../theme";
import { Link } from "react-router-dom";
import useButtonStyles from "../../styles/useButtonStyles";
import InfiniteTable from "../Table/InfiniteScroll/InfiniteTable";
import { SearchToolTip, filterConstants } from "../../constants/AppConstants";
import useGetMerchants from "../../Hooks/merchant/useGetMerchants";
import SearchInput from "../../Shared/Components/SearchInput/SearchInput";
import { getEncodedValue } from "../forms/utility";
import { usePermissionGetter } from "../../Hooks/Permissions/userPermissionGetter";
import { CommonButton } from "../../Shared/Components/Buttons/CommonButton";

export const ViewMerchant = () => {
  const { getUserPermission: getMerchantPermission } = usePermissionGetter(
    "merchant",
    "merchants"
  );
  const { fetchMerchantList, merchantLoading, merchantData, isMerchantError } =
    useGetMerchants();
  const list = [filterConstants.Yes, filterConstants.No];
  const statusList = [filterConstants.Active, filterConstants.Inactive];
  const buttonStyles = useButtonStyles();
  const [openFilter, setOpenFilter] = useState(false);
  const [filterActive, setFilterActive] = useState(false);
  const [isInitialApiCall, setIsInitialApiCall] = useState(true);
  const [merchantDataList, setMerchantDataList] = useState([]);
  const [loading, setLoading] = useState(false);

  const { merchantList, entireListOfMerchants: entireList } = useAppSelector(
    (state: any) => state.persistReducers.getMerchantList
  );
  const handleClose = () => {
    setOpenFilter(false);
  };
  const subCategory = entireList.reduce((sub: any, item: any) => {
    if (
      item.sub_category !== "-" &&
      item.sub_category !== " " &&
      !sub.includes(item.sub_category)
    ) {
      sub.push(item.sub_category);
    }
    return sub;
  }, []);
  const zoneList = entireList.reduce((sub: any, item: any) => {
    if (
      item.store_zone !== "-" &&
      item.store_zone !== " " &&
      !sub.includes(item.store_zone)
    ) {
      sub.push(item.store_zone);
    }
    return sub;
  }, []);

  const [filterState, setFilterState] = useState({
    SubCategory: "",
    voucherAcceptance: "",
    EarnPoints: "",
    partner: "",
    status: "",
    zone: "",
  });

  useEffect(() => {
    setMerchantDataList(merchantData);
    if (!merchantLoading) setLoading(false);
  }, [merchantLoading]);

  const resetFilterState = () => {
    setFilterState({
      SubCategory: "",
      voucherAcceptance: "",
      EarnPoints: "",
      partner: "",
      status: "",
      zone: "",
    });
    setFilterActive(false);
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
    setMerchantDataList(merchantList);
    setOpenFilter(false);
    // setIsInitialApiCall(true);
  };

  const applyMerchantFilter = () => {
    // setIsInitialApiCall(true);
    filterData();
    setOpenFilter(false);
    const anyFilterActive = Object.values(filterState).some(
      (value) => value !== ""
    );
    if (anyFilterActive) {
      setFilterActive(true);
    }
  };
  const searchInputRef = useRef<HTMLInputElement>();
  const handleSearch = () => {
    setLoading(true);
    const searchValue = searchInputRef.current
      ? searchInputRef.current.value.toLowerCase()
      : "";
    let merchant_List = [];
    if (searchValue) {
      const searchDataFromFilter = merchantList.filter(
        (merchant: any) =>
          merchant.merchant_name.toLowerCase().includes(searchValue) ||
          merchant.company_name.toLowerCase().includes(searchValue) ||
          merchant.unit_number.toLowerCase().includes(searchValue)
      );
      merchant_List = searchDataFromFilter;
    } else {
      merchant_List = merchantList;
    }
    setMerchantDataList(merchant_List);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };

  const bindSearchAndFilter = (canHaveExistingData?: boolean) => {
    filterData();
    setIsInitialApiCall(false);
    setOpenFilter(false);
  };
  useEffect(() => {
    // isInitialApiCall && bindSearchAndFilter();
    isInitialApiCall && fetchMerchantList();
    setLoading(true);
  }, [isInitialApiCall]);

  const filterData = () => {
    setLoading(true);
    let filteredData = merchantList.filter((merchant: any) => {
      const subCategoryFilter =
        !filterState.SubCategory ||
        merchant.directory_subcategory === filterState.SubCategory;
      const voucherAcceptanceFilter =
        !filterState.voucherAcceptance ||
        merchant.acceptsVoucher === filterState.voucherAcceptance;
      const earnPointsFilter =
        !filterState.EarnPoints ||
        merchant.payWithPoints === filterState.EarnPoints;
      const partnerFilter =
        !filterState.partner || merchant.Partner === filterState.partner;
      const statusFilter =
        !filterState.status ||
        merchant.status.toLowerCase() === filterState.status.toLowerCase();
      const zoneFilter =
        !filterState.zone || merchant.zone === filterState.zone;
      return (
        subCategoryFilter &&
        voucherAcceptanceFilter &&
        earnPointsFilter &&
        partnerFilter &&
        statusFilter &&
        zoneFilter
      );
    });
    setTimeout(() => {
      setLoading(false);
    }, 1000);
    setMerchantDataList(filteredData);
  };

  return (
    <Grid
      borderRadius={"16px"}
      sx={{ background: theme.color?.background }}
      p={4}
      px={2}
    >
      <Grid container display={"flex"} flexDirection={"column"} width={"100%"}>
        <Grid
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Grid alignItems={"left"} pl={4} pr={10} direction={"row"}>
            <Typography
              variant="h5"
              sx={{
                fontFamily: theme?.font?.fontFamily.primary,
                fontWeight: theme.font?.fontWeight.thicker,
                fontSize: theme.font?.fontSize.large,
              }}
            >
              Merchants
            </Typography>
          </Grid>
          <Grid></Grid>
          <Grid display={"flex"}>
            <Grid
              display={"flex"}
              justifyContent={"center"}
              px={0}
              py={3}
              direction={"row"}
            >
              {getMerchantPermission("read") && (
                <Grid display={"flex"} gap={3}>
                  <SearchInput
                    HelpTip={SearchToolTip.Merchants}
                    onCallBack={handleSearch}
                    ref={searchInputRef}
                  />
                  <Button
                    variant="text"
                    startIcon={
                      filterActive ? (
                        <FilterAltIcon sx={{ color: theme.color?.secondary }} />
                      ) : (
                        <FilterAltOutlinedIcon />
                      )
                    }
                    sx={{
                      color: theme.color?.newFilterGrey,
                      textTransform: "capitalize",
                    }}
                    onClick={() => {
                      setOpenFilter(true);
                    }}
                  >
                    Filter
                  </Button>
                </Grid>
              )}
              <Dialog
                onClose={handleClose}
                open={openFilter}
                sx={{ ml: "60vw" }}
              >
                <Grid sx={{ width: "483px", py: 4, px: 2 }}>
                  <DialogTitle
                    display={"flex"}
                    justifyContent={"space-between"}
                    borderBottom={theme.border?.smallGrey}
                  >
                    <Typography
                      sx={{
                        fontFamily: theme.font?.fontFamily.primary,
                        color: theme.color?.primary,
                        fontSize: theme.font?.fontSize.large,
                        fontWeight: theme.font?.fontWeight.thicker,
                      }}
                    >
                      Filter
                    </Typography>
                    <IconButton onClick={() => setOpenFilter(false)}>
                      <CloseOutlinedIcon />
                    </IconButton>
                  </DialogTitle>
                  <DialogContent sx={{ borderBottom: theme.border?.smallGrey }}>
                    <Grid>
                      <Grid borderBottom={theme.border?.smallGrey} mt={5}>
                        <Typography
                          sx={{
                            fontFamily: theme.font?.fontFamily.primary,
                            fontSize: theme.font?.fontSize.medium,
                            fontWeight: theme.font?.fontWeight.thick,
                          }}
                        >
                          Subcategory
                        </Typography>
                        <Grid
                          gap={2}
                          mt={2}
                          display={"flex"}
                          sx={{
                            width: "80%",
                          }}
                        >
                          <FormControl
                            fullWidth
                            size="small"
                            sx={{
                              with: "100%",
                            }}
                          >
                            <Select
                              id=""
                              value={filterState.SubCategory}
                              onChange={(e) =>
                                setFilterState((prev) => ({
                                  ...prev,
                                  SubCategory: e.target.value,
                                }))
                              }
                            >
                              {subCategory.map((name: any) => (
                                <MenuItem value={name}>{name}</MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                      </Grid>
                      <Grid borderBottom={theme.border?.smallGrey} mt={5}>
                        <Typography
                          sx={{
                            fontFamily: theme.font?.fontFamily.primary,
                            fontSize: theme.font?.fontSize.medium,
                            fontWeight: theme.font?.fontWeight.thick,
                          }}
                        >
                          Voucher Acceptance
                        </Typography>
                        <Grid
                          gap={2}
                          mt={2}
                          display={"flex"}
                          sx={{
                            width: "80%",
                          }}
                        >
                          <FormControl
                            fullWidth
                            size="small"
                            sx={{
                              with: "100%",
                            }}
                          >
                            <Select
                              id=""
                              value={filterState.voucherAcceptance}
                              onChange={(e) =>
                                setFilterState((prev) => ({
                                  ...prev,
                                  voucherAcceptance: e.target.value,
                                }))
                              }
                            >
                              {list.map((name: any) => (
                                <MenuItem value={name}>{name}</MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                      </Grid>
                      <Grid borderBottom={theme.border?.smallGrey} mt={5}>
                        <Typography
                          sx={{
                            fontFamily: theme.font?.fontFamily.primary,
                            fontSize: theme.font?.fontSize.medium,
                            fontWeight: theme.font?.fontWeight.thick,
                          }}
                        >
                          Earn Points
                        </Typography>
                        <Grid
                          gap={2}
                          mt={2}
                          display={"flex"}
                          sx={{
                            width: "80%",
                          }}
                        >
                          <FormControl
                            fullWidth
                            size="small"
                            sx={{
                              with: "100%",
                            }}
                          >
                            <Select
                              id=""
                              value={filterState.EarnPoints}
                              onChange={(e) =>
                                setFilterState((prev) => ({
                                  ...prev,
                                  EarnPoints: e.target.value,
                                }))
                              }
                            >
                              {list.map((name: any) => (
                                <MenuItem value={name}>{name}</MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                      </Grid>
                      <Grid borderBottom={theme.border?.smallGrey} mt={5}>
                        <Typography
                          sx={{
                            fontFamily: theme.font?.fontFamily.primary,
                            fontSize: theme.font?.fontSize.medium,
                            fontWeight: theme.font?.fontWeight.thick,
                          }}
                        >
                          Partner
                        </Typography>
                        <Grid
                          gap={2}
                          mt={2}
                          display={"flex"}
                          sx={{
                            width: "80%",
                          }}
                        >
                          <FormControl
                            fullWidth
                            size="small"
                            sx={{
                              with: "100%",
                            }}
                          >
                            <Select
                              id=""
                              value={filterState.partner}
                              onChange={(e) =>
                                setFilterState((prev) => ({
                                  ...prev,
                                  partner: e.target.value,
                                }))
                              }
                            >
                              {list.map((name: any) => (
                                <MenuItem value={name}>{name}</MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                      </Grid>
                      <Grid borderBottom={theme.border?.smallGrey} mt={5}>
                        <Typography
                          sx={{
                            fontFamily: theme.font?.fontFamily.primary,
                            fontSize: theme.font?.fontSize.medium,
                            fontWeight: theme.font?.fontWeight.thick,
                          }}
                        >
                          Status
                        </Typography>
                        <Grid
                          gap={2}
                          mt={2}
                          display={"flex"}
                          sx={{
                            width: "80%",
                          }}
                        >
                          <FormControl
                            fullWidth
                            size="small"
                            sx={{
                              with: "100%",
                            }}
                          >
                            <Select
                              id=""
                              value={filterState.status}
                              onChange={(e) =>
                                setFilterState((prev) => ({
                                  ...prev,
                                  status: e.target.value,
                                }))
                              }
                            >
                              {statusList.map((name: any) => (
                                <MenuItem value={name}>{name}</MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                      </Grid>
                      <Grid borderBottom={theme.border?.smallGrey} mt={5}>
                        <Typography
                          sx={{
                            fontFamily: theme.font?.fontFamily.primary,
                            fontSize: theme.font?.fontSize.medium,
                            fontWeight: theme.font?.fontWeight.thick,
                          }}
                        >
                          Zone
                        </Typography>
                        <Grid
                          gap={2}
                          mt={2}
                          display={"flex"}
                          sx={{
                            width: "80%",
                          }}
                        >
                          <FormControl
                            fullWidth
                            size="small"
                            sx={{
                              with: "100%",
                            }}
                          >
                            <Select
                              id=""
                              value={filterState.zone}
                              onChange={(e) =>
                                setFilterState((prev) => ({
                                  ...prev,
                                  zone: e.target.value,
                                }))
                              }
                            >
                              {zoneList.map((name: any) => (
                                <MenuItem value={name}>{name}</MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                      </Grid>
                    </Grid>
                  </DialogContent>
                  <DialogActions sx={{ pr: 4, gap: 1, pt: 3 }}>
                    <Button
                      onClick={() => {
                        resetFilterState();
                      }}
                      sx={{ ...buttonStyles.outlinedSecondary }}
                    >
                      Reset
                    </Button>
                    <Button
                      sx={{ ...buttonStyles.containedSecondary }}
                      onClick={applyMerchantFilter}
                    >
                      Apply
                    </Button>
                  </DialogActions>
                </Grid>
              </Dialog>
            </Grid>
            <Grid
              display={"flex"}
              justifyContent={"right"}
              px={5}
              py={3}
              direction={"row"}
            >
              {getMerchantPermission("create") && (
                <Grid item display={"flex"} gap={1}>
                  <Link to={"/addMerchant"}>
                    <CommonButton
                      buttonTitle="Add Merchant"
                      variant="outlined"
                      color="secondary"
                    />
                  </Link>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>

        <Grid item px={"1rem"} width={"100%"} mt={2}>
          {getMerchantPermission("read") && (
            <InfiniteTable
              header={MerchantColumns}
              contentItems={merchantDataList}
              metaData={merchantMetaData}
              hasMoreRecords={false}
              isInitialLoading={merchantLoading || loading}
              isError={isMerchantError}
              totalRecords={merchantDataList?.length}
            />
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};
